import * as React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SideMenu from './Components/VendorOnboarding/SideMenu';
import { Box, Button, Grid } from '@mui/material';
import { useState } from 'react';
import TextField from '@mui/material/TextField';
// import { GetAllRequestForFilter } from 'API/Approval/api';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import SubCard from 'ui-component/cards/SubCard';
import { GetAllVendors } from 'API/VendorOnboarding/api';

const VendorOnboardingStatus = () => {
  const [FilterData, setFilterData] = useState({ vendor_name: '' });

  const [CallBackFunctions, setCallBackFunctions] = useState(null);
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('success');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);



  // const handleAlertOpen = () => {
  //   setOpen(true);
  // };

  const handleAlertSpecialOpen=(message,type)=>{
    setOpen(true)
    setMessage(message)
    setSeverity(type)
  }

  const handleAlertClose = () => {
    setOpen(false);
  };

  const handleFilterChange = (field, value) => {
    if (/^[a-zA-Z ]*$/.test(value)) {
      setFilterData({ ...FilterData, [field]: value });
    }
  };

  const handleFilterClear = () => {
    setFilterData({ vendor_name: '' });
    GetAllVendors(CallBackFunctions.setData, setIsLoading,"","", handleAlertSpecialOpen,1,10,CallBackFunctions.type);

  };

  const handleFilter = () => {
    GetAllVendors(CallBackFunctions.setData, setIsLoading,FilterData.vendor_name,"", handleAlertSpecialOpen,1,10,CallBackFunctions.type);
  };

  // console.log("callback", CallBackFunctions);

  return (
    <Box>
      <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar anchorOrigin={{ horizontal: 'right', vertical: 'top' }} open={open} autoHideDuration={6000} onClose={handleAlertClose}>
        <Alert onClose={handleAlertClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>

      <Grid container mb={1}>
        <Grid item xl={12} lg={12} xs={12}>
          <SubCard>
            <Grid container spacing={1}>

              <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                <TextField
                  size='small'
                  id="outlined-basic"
                  label="Vendor Name"
                  fullWidth
                  value={FilterData.vendor_name}
                  variant="outlined"
                  onChange={(e) => handleFilterChange('vendor_name', e.target.value)}
                />
              </Grid>

              <Grid item xl={2} lg={2} md={2} sm={12} xs={12} display={'flex'} alignItems={'center'}>
                <Button variant="outlined" color="secondary" onClick={() => handleFilterClear()} sx={{ marginRight: '10px' }}>
                  clear
                </Button>
                {/* </Grid>
              <Grid item xl={2} lg={2} md={2} sm={12} xs={12}> */}
                <Button variant="contained" color="secondary" onClick={() => handleFilter()}>
                  search
                </Button>
              </Grid>
            </Grid>
            {/* <Grid container gap={1} mt={1} justifyContent="center"> */}
            {/* </Grid> */}
          </SubCard>
        </Grid>
      </Grid>

      <MainCard sx={{ height: '100%', overflowX: 'scroll' }}>
        <SideMenu FilterData={FilterData} callback={setCallBackFunctions} />
      </MainCard>
    </Box>
  );
};

export default VendorOnboardingStatus;
